import React from 'react'
import { createBrowserRouter, Navigate, RouterProvider, redirect } from 'react-router-dom'
import { useGlobalState } from 'state'

import { Q00 } from 'pages/Q00'
import { Q00Map } from 'pages/Q00Map'
import { Q01_04 } from 'pages/Q01_04'
import { Q05 } from 'pages/Q05'
import { Q06 } from 'pages/Q06'
import { Q07 } from 'pages/Q07'
import { Q08 } from 'pages/Q08'
import { Q09 } from 'pages/Q09'
import { Q10 } from 'pages/Q10'
import { Q11 } from 'pages/Q11'
import { Q12 } from 'pages/Q12'
import { Q13 } from 'pages/Q13'
import { Q14 } from 'pages/Q14'
import { Q15 } from 'pages/Q15'
import { Q16 } from 'pages/Q16'
import { Q17 } from 'pages/Q17'
import { QList } from 'pages/QList'
import { ContinueSheet } from 'pages/ContinueSheet'
import { Score } from 'pages/Score'
import { getQuestionKey } from 'common/utils'
import { Top } from 'pages/Top'

const acceptPrivacy = async () => {
  const answers = JSON.parse(sessionStorage.getItem('answers') || '{}')
  const key = getQuestionKey(-1, 99)
  const answer = answers[key] || null
  if (answer === null || answer.value !== 'yes') {
    return redirect('/')
  } else {
    return null
  }
}

const router = createBrowserRouter([
  { path: '/', element: <Top /> },
  { path: '/0', element: <Q00 /> },
  { path: '/sheet/:id', element: <ContinueSheet /> },
  {
    loader: acceptPrivacy,
    children: [
      { path: '/map', element: <Q00Map /> },
      { path: '/1-4/:debugRiskCode?', element: <Q01_04 /> },
      { path: '/5', element: <Q05 /> },
      { path: '/6', element: <Q06 /> },
      { path: '/7', element: <Q07 /> },
      { path: '/8', element: <Q08 /> },
      { path: '/9', element: <Q09 /> },
      { path: '/10', element: <Q10 /> },
      { path: '/11', element: <Q11 /> },
      { path: '/12', element: <Q12 /> },
      { path: '/13', element: <Q13 /> },
      { path: '/14', element: <Q14 /> },
      { path: '/15', element: <Q15 /> },
      { path: '/16', element: <Q16 /> },
      { path: '/17', element: <Q17 /> },
      { path: '/qlist', element: <QList /> },
      { path: '/score', element: <Score /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])

export const AppRouter = () => {
  const state = useGlobalState()

  React.useEffect(() => {
    (async() => {
      await state.scoring.fetchPulldown()
    })()
  }, [])

  return <RouterProvider router={router} />
}
